// extracted by css-extract-rspack-plugin
export default {"toolbar":"LsPTCgPfuokldVvQ","toolbarPrimary":"QmC8YOwtMssEepxa","searchField":"FrptNap2IMU1vPhv","checkIcon":"sE5rlz5h8kI50Tno"};